import React from "react";

import { useIntl } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { ListingData, useListingData } from "~/context/ListingPageDataContext";
import { useMessagesData } from "~/context/MessagesDataContext";
import { useTransactable } from "~/hooks/use-transactable";
import useRedirectToSigninSignup from "~/hooks/useRedirectToSigninSignup";
import { useProfileData } from "~/queries/profile/useProfile";
import { BookListingQuote, IFaqs } from "~/types/api-types";

import { handleStartBookingAnalytics } from "../book-listing-analytics";
import { getBookListingButtonText } from "../book-listing-utils";

interface MobileBookListingButtonProps {
  faqs?: IFaqs;
  pageTitle: string;
  quote: BookListingQuote | undefined;
}

export const MobileBookListingButton = ({
  faqs,
  pageTitle,
  quote,
}: MobileBookListingButtonProps) => {
  const { checkTransactable } = useTransactable();

  const { data: listingData = {} as ListingData } = useListingData();
  const { booking } = quote?.spaceRentalContract?.meta || {};

  const profile = useProfileData();
  const messages = useMessagesData();

  const intl = useIntl();

  const { handleRedirectToSignupPage, isUserLoggedIn } =
    useRedirectToSigninSignup();

  const goToCheckout = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const requestParam = searchParams.get("request");
    const url = requestParam
      ? `/bkc/${listingData.listingId}?request=${requestParam}/mobile`
      : `/bkc/${listingData.listingId}/mobile`;

    if (!isUserLoggedIn) {
      handleRedirectToSignupPage("fee", url);
      return;
    }

    handleStartBookingAnalytics({
      listingData,
      faqs,
      profile,
      pageTitle,
      userMessagesCount: messages?.threadCount,
    });

    checkTransactable(() => {
      window.location.href = url;
    });
  };

  const buttonText = getBookListingButtonText({
    quote,
    booking,
    listingData,
    intl,
  });

  return (
    <Button onClick={goToCheckout} appearance="purple" fullWidth>
      {buttonText}
    </Button>
  );
};
